<template>
<div style="flex: 1;overflow: auto;">
  <slot></slot>
</div>
</template>

<script>
export default {
  name: "YSpacer"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/YUI/YSpacer.vue